module.exports = {

    //首充状态
    Update_First_Charge_Status: "Update_First_Charge_Status"
    //七天登录
    , UPDATE_SEVEN_LOGIN_STATUS: "UPDATE_SEVEN_LOGIN_STATUS"
    , UPDATE_SEVEN_LOGIN_REWARDS: "UPDATE_SEVEN_LOGIN_REWARDS"
    //七天排行
    , UPDATE_SEVEN_RANK_LIST: "UPDATE_SEVEN_RANK_LIST"
    , UPDATE_SEVEN_RANK_DATA: "UPDATE_SEVEN_RANK_DATA"

    , UPDATE_HOLIDAY_SIGNLE: "UPDATE_HOLIDAY_SIGNLE"

    , UPDATE_HOLIDAY_TAB_STATUS: "UPDATE_HOLIDAY_TAB_STATUS"

    , UPDATE_Delete_Btn: "UPDATE_Delete_Btn"

    , UPDATE_91005_Btn: "UPDATE_91005_Btn"

    , UPDATE_SEVENT_QUEST: "UPDATE_SEVENT_QUEST"

    , UPDATE_SEVENT_LOTTERY: "UPDATE_SEVENT_LOTTERY"
    , UPDATE_LOTTERY_REDPOINT: "UPDATE_LOTTERY_REDPOINT"

    //跨服排行
    , UPDATE_CROSSSERVER_RANK_LIST: "UPDATE_CROSSSERVER_RANK_LIST"//UPDATE_SEVEN_RANK_LIST
    , UPDATE_CROSSSERVER_RANK_DATA: "UPDATE_CROSSSERVER_RANK_DATA"//UPDATE_SEVEN_RANK_DATA
    , UPDATE_CROSSSERVER_QUEST: "UPDATE_CROSSSERVER_QUEST"// UPDATE_SEVENT_QUEST

    //七天目标
    , UPDATE_SEVENT_GOAL: "UPDATE_SEVENT_GOAL"

    //七天领取
    , UPDATE_SEVENT_GET: "UPDATE_SEVENT_GET"

    //直购礼包
    , UPDATE_DIRECTGIFT_GET: "UPDATE_DIRECTGIFT_GET"

    //探宝
    , UPDATE_LUCKYROUND_GET: "UPDATE_LUCKYROUND_GET"
    , UPDATE_LUCKLY_DATA: "UPDATE_LUCKLY_DATA"
    //探宝返回
    , TREASURE_SUCCESS_DATA: "TREASURE_SUCCESS_DATA"
    //探宝记录
    , UPDATA_TREASURE_LOG_DATA: "UPDATA_TREASURE_LOG_DATA"
    //弹窗请求的协议
    , UPDATA_TREASURE_POPUPS_SEND: "UPDATA_TREASURE_POPUPS_SEND"
    //刷新
    , UPDATA_TREASURE_REFRESH: "UPDATA_TREASURE_REFRESH"
    //升级有礼
    , UPDATE_LEVEL_UP_GIFT: "UPDATE_LEVEL_UP_GIFT"

    //限时礼包入口
    , LIMIT_GIFT_MAIN_EVENT: "LIMIT_GIFT_MAIN_EVENT"

    //排行奖励列表
    , RANK_REWARD_LIST: "RANK_REWARD_LIST"

    // 基金活动开启类型更新
    , UPDATA_FUND_ID_LIST_EVENT: "UPDATA_FUND_ID_LIST_EVENT"

    // 基金数据更新
    , UPDATA_FUND_DATA_EVENT: "UPDATA_FUND_DATA_EVENT"

    // 基金红点更新
    , UPDATA_FUND_RED_STATUS_EVENT: "UPDATA_FUND_RED_STATUS_EVENT"

    //元宵冒险
    , YUAN_ZHEN_DATA_EVENT: "YUAN_ZHEN_DATA_EVENT"
    //元宵冒险 推送更新
    , YUAN_ZHEN_UPDATA_EVENT: "YUAN_ZHEN_UPDATA_EVENT"
    //元宵冒险 领任务
    , YUAN_ZHEN_TASK_EVENT: "YUAN_ZHEN_TASK_EVENT"

    //杂货铺
    , UPDATE_STORE_DATA_EVENT : "UPDATE_STORE_DATA_EVENT"
    //杂货铺 购买成功
    , UPDATE_STORE_DATA_SUCCESS_EVENT : "UPDATE_STORE_DATA_SUCCESS_EVENT"

    //是否可充值
    ,Is_Charge_Event: "Is_Charge_Event"

    // 刷新红点(活动期间仅显示一次)
    ,SHOW_ACTIVITY_RED_POINT : "SHOW_ACTIVITY_RED_POINT"

    //触发礼包
    ,TRIGGER_GIFT_EVENT : "TRIGGER_GIFT_EVENT"

    //时装信息
    ,SKIN_INFO_EVENT : "SKIN_INFO_EVENT"
}